import{msalInstance,SCOPES,TEAMS_SCOPES,SP_SITE,LIST_TASKS,LIST_COMPANY,LIST_USERS,LIST_SETTINGS,LIST_PROJECTS,LIST_FEEDBACK,LIST_HISTORY,LIST_ISSUES}from"./config";

// Normalize any email variant to firstname.lastname@dacrobotics.com
function normEmail(e){if(!e)return"";const[local]=e.toLowerCase().split("@");return local.replace(/_/g,".")+"@dacrobotics.com";}

async function getToken(){
  const accounts=msalInstance.getAllAccounts();
  if(!accounts.length) throw new Error("Not signed in");
  const res=await msalInstance.acquireTokenSilent({scopes:SCOPES,account:accounts[0]});
  return res.accessToken;
}

async function gql(method,path,body){
  const token=await getToken();
  const opts={method,headers:{"Authorization":"Bearer "+token,"Content-Type":"application/json"}};
  if(body) opts.body=JSON.stringify(body);
  const res=await fetch("https://graph.microsoft.com/v1.0"+path,opts);
  if(!res.ok){const e=await res.text();throw new Error(e);}
  if(res.status===204) return null;
  return res.json();
}

function safeParseArray(val){
  if(!val) return[];
  try{const p=JSON.parse(val);return Array.isArray(p)?p:[];}catch(e){return[];}
}

function spToTask(item,listType="tasks"){
  const f=item.fields||item;
  let standupHistory=[];
  try{ if(f.StandupHistory) standupHistory=JSON.parse(f.StandupHistory); }catch(e){}
  let noteHistory=[];
  try{ if(f.NoteHistory) noteHistory=JSON.parse(f.NoteHistory); }catch(e){}
  const rawId=String(item.id||f.id);
  return{
    id:(listType==="company"?"c":"t")+"-"+rawId,
    spId:rawId,
    listType,
    title:f.Title||f.title||"",
    desc:f.TaskDescription||f.Description||f.desc||"",
    pri:f.Priority||f.pri||"medium",
    sta:f.Status||f.sta||"todo",
    vis:f.Visibility||f.vis||(listType==="company"?"company":"personal"),
    dueDate:f.DueDate?String(f.DueDate).slice(0,10):f.dueDate||"",
    own:normEmail(f.OwnerEmail||f.OwnerId||f.own||""),
    asgn:normEmail(f.AssigneeEmail||f.AssigneeId||f.asgn||""),
    acc:f.AcceptanceStatus||f.Acceptance||f.acc||"",
    reqBy:f.RequestedBy||f.reqBy||"",
    blockReason:f.BlockReason||"",
    src:f.Source||f.src||"manual",
    deps:safeParseArray(f.Dependencies),
    tags:safeParseArray(f.Tags),
    notes:f.Notes||f.notes||"",
    docs:safeParseArray(f.LinkedDocs||f.Docs),
    reminderDate:f.ReminderDate?String(f.ReminderDate).slice(0,10):"",
    reminderOutlook:f.ReminderOutlook||false,
    reminderTeams:f.ReminderTeams||false,
    reminderEmail:f.ReminderEmail||false,
    standup:f.Standup===true||f.Standup==="Yes"||f.Standup===1||false,
    standupHistory,
    noteHistory,
    project:f.Project||f.project||"",
    completedDate:f.CompletedDate?String(f.CompletedDate).slice(0,10):"",
    recurrence:(()=>{try{return f.Recurrence?JSON.parse(f.Recurrence):null;}catch(e){return null;}})()
  };
}

function taskToSp(task){
  return{
    Title:task.title,
    TaskDescription:task.desc||"",
    Priority:task.pri,
    Status:task.sta,
    Visibility:task.vis,
    DueDate:task.dueDate?task.dueDate+"T12:00:00Z":null,
    OwnerEmail:task.own,
    AssigneeEmail:task.asgn||"",
    AcceptanceStatus:task.acc||"",
    RequestedBy:task.reqBy||"",
    BlockReason:task.blockReason||"",
    Source:task.src||"manual",
    Dependencies:JSON.stringify(task.deps||[]),
    Tags:JSON.stringify(task.tags||[]),
    Notes:task.notes||"",
    LinkedDocs:JSON.stringify(task.docs||[]),
    ReminderDate:task.reminderDate?task.reminderDate+"T12:00:00Z":null,
    ReminderOutlook:task.reminderOutlook||false,
    ReminderTeams:task.reminderTeams||false,
    ReminderEmail:task.reminderEmail||false,
    Standup:task.standup?true:false,
    StandupHistory:JSON.stringify(task.standupHistory||[]),
    NoteHistory:JSON.stringify(task.noteHistory||[]),
    Project:task.project||"",
    Recurrence:task.recurrence?JSON.stringify(task.recurrence):"",
    CompletedDate:task.completedDate||""
  };
}

export async function getMe(token){
  const res=await fetch("https://graph.microsoft.com/v1.0/me",{headers:{"Authorization":"Bearer "+token}});
  if(!res.ok){const e=await res.text();throw new Error(e);}
  return res.json();
}

export async function getTasks(token,userEmail){
  const listId=LIST_TASKS;
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${listId}/items?$expand=fields&$top=500`);
  return(res.value||[]).map(i=>spToTask(i,"tasks")).filter(t=>t.own.toLowerCase()===userEmail.toLowerCase()||t.asgn.toLowerCase()===userEmail.toLowerCase()||(t.vis==="assigned"&&t.asgn.toLowerCase()===userEmail.toLowerCase()));
}

export async function getCompanyTasks(token){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_COMPANY}/items?$expand=fields&$top=500`);
  return(res.value||[]).map(i=>spToTask(i,"company"));
}

export async function getAllTasksForManager(token,reportEmails){
  const listId=LIST_TASKS;
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${listId}/items?$expand=fields&$top=500`);
  const all=(res.value||[]).map(i=>spToTask(i,"tasks"));
  return all.filter(t=>reportEmails.map(e=>e.toLowerCase()).includes(t.own.toLowerCase())&&t.vis!=="personal");
}

export async function createTask(token,task){
  const listId=task.vis==="company"?LIST_COMPANY:LIST_TASKS;
  const res=await gql("POST",`/sites/${SP_SITE}/lists/${listId}/items`,{fields:taskToSp(task)});
  return spToTask(res,task.vis==="company"?"company":"tasks");
}

export async function updateTask(token,task){
  const listId=task.listType==="company"?LIST_COMPANY:LIST_TASKS;
  await gql("PATCH",`/sites/${SP_SITE}/lists/${listId}/items/${task.spId}/fields`,taskToSp(task));
  return task;
}

export async function deleteTask(token,task){
  const listId=task.listType==="company"?LIST_COMPANY:LIST_TASKS;
  await gql("DELETE",`/sites/${SP_SITE}/lists/${listId}/items/${task.spId}`);
}

// Toggle standup flag on a task
export async function updateTaskStandup(task,standupValue){
  const listId=task.listType==="company"?LIST_COMPANY:LIST_TASKS;
  await gql("PATCH",`/sites/${SP_SITE}/lists/${listId}/items/${task.spId}/fields`,{Standup:standupValue});
  return{...task,standup:standupValue};
}

// Add a standup note — appends to standupHistory and saves
export async function addStandupNote(task,note,newStatus){
  const today=new Date().toISOString().slice(0,10);
  const history=[...(task.standupHistory||[])];
  // Replace today's entry if it exists, otherwise append
  const todayIdx=history.findIndex(h=>h.date===today);
  const entry={date:today,status:newStatus||task.sta,note,updatedAt:new Date().toISOString()};
  if(todayIdx>=0) history[todayIdx]=entry;
  else history.push(entry);
  const updated={...task,sta:newStatus||task.sta,standupHistory:history};
  await updateTask(null,updated);
  return updated;
}

export async function getStandupTasks(){
  // Fetch all tasks from both lists — SP Yes/No OData filters are unreliable,
  // so filter standup=true client-side
  const[r1,r2]=await Promise.all([
    gql("GET",`/sites/${SP_SITE}/lists/${LIST_TASKS}/items?$expand=fields&$top=999`),
    gql("GET",`/sites/${SP_SITE}/lists/${LIST_COMPANY}/items?$expand=fields&$top=999`)
  ]);
  return[
    ...(r1.value||[]).map(i=>spToTask(i,"tasks")),
    ...(r2.value||[]).map(i=>spToTask(i,"company"))
  ].filter(t=>t.standup);
}

export async function getUsers(token){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_USERS}/items?$expand=fields&$top=500`);
  return(res.value||[]).map(i=>{
    const f=i.fields||i;
    return{
      id:String(i.id),
      spId:String(i.id),
      email:normEmail(f.UserEmail||""),
      displayName:f.DisplayName||"",
      role:f.Role||"User",
      manager1:normEmail(f.Manager1Email||""),
      manager2:normEmail(f.Manager2Email||""),
      isActive:f.IsActive!==false&&f.IsActive!=="No",
      productTrackRole:f.ProductTrackRole||"none"
    };
  });
}

function spToUser(item){
  const f=item.fields||item;
  return{id:String(item.id),spId:String(item.id),email:(f.UserEmail||"").toLowerCase(),displayName:f.DisplayName||"",role:f.Role||"User",manager1:f.Manager1Email||"",manager2:f.Manager2Email||"",isActive:f.IsActive!==false,productTrackRole:f.ProductTrackRole||"none"};
}

async function getAllUserItems(){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_USERS}/items?$expand=fields&$top=500`);
  return res.value||[];
}

export async function getUserRecord(token,email){
  const items=await getAllUserItems();
  const match=items.find(i=>(i.fields?.UserEmail||"").toLowerCase()===email.toLowerCase());
  return match?spToUser(match):null;
}

export async function upsertUser(token,user){
  const items=await getAllUserItems();
  const match=items.find(i=>(i.fields?.UserEmail||"").toLowerCase()===user.email.toLowerCase());
  if(match){
    const f=match.fields||match;
    // Use existing role if caller doesn't provide one (login path never sends role)
    const fields={
      UserEmail:user.email,
      DisplayName:user.displayName||f.DisplayName||"",
      Role:user.role||f.Role||"User",
      Manager1Email:user.manager1!==undefined?user.manager1:(f.Manager1Email||""),
      Manager2Email:user.manager2!==undefined?user.manager2:(f.Manager2Email||""),
      IsActive:user.isActive!==undefined?user.isActive:(f.IsActive!==false),
      ProductTrackRole:user.productTrackRole!==undefined?user.productTrackRole:(f.ProductTrackRole||"none")
    };
    await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_USERS}/items/${match.id}/fields`,fields);
    return{id:String(match.id),spId:String(match.id),email:user.email,displayName:fields.DisplayName,role:fields.Role,manager1:fields.Manager1Email,manager2:fields.Manager2Email,isActive:fields.IsActive,productTrackRole:fields.ProductTrackRole};
  } else {
    const fields={UserEmail:user.email,DisplayName:user.displayName||"",Role:user.role||"User",Manager1Email:user.manager1||"",Manager2Email:user.manager2||"",IsActive:true};
    const res=await gql("POST",`/sites/${SP_SITE}/lists/${LIST_USERS}/items`,{fields});
    return{id:String(res.id||""),spId:String(res.id||""),email:user.email,displayName:user.displayName||"",role:user.role||"User",manager1:user.manager1||"",manager2:user.manager2||"",isActive:true};
  }
}

export async function getSettings(){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_SETTINGS}/items?$expand=fields&$top=100`);
  const settings={};
  (res.value||[]).forEach(i=>{
    const f=i.fields||i;
    if(f.SettingKey) settings[f.SettingKey]={value:f.SettingValue||"",spId:String(i.id)};
  });
  return settings;
}

export async function saveSetting(token,key,value,spId,modifiedBy){
  const fields={Title:key,SettingKey:key,SettingValue:String(value),LastModifiedBy:modifiedBy||""};
  if(spId){
    await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_SETTINGS}/items/${spId}/fields`,fields);
  } else {
    // Fall back to fetch-all to find existing by key
    const all=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_SETTINGS}/items?$expand=fields&$top=100`);
    const match=(all.value||[]).find(i=>(i.fields?.SettingKey||"")===key);
    if(match){
      await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_SETTINGS}/items/${match.id}/fields`,fields);
    } else {
      await gql("POST",`/sites/${SP_SITE}/lists/${LIST_SETTINGS}/items`,{fields});
    }
  }
}

function spToProject(item){
  const f=item.fields||item;
  return{
    id:String(item.id),
    spId:String(item.id),
    customerName:f.CustomerName||"",
    jobNumber:f.JobNumber||"",
    projectName:f.ProjectName||"",
    projectType:f.ProjectType||"customer",
    isQuote:f.IsQuote===true||f.IsQuote==="Yes"||false,
    isActive:f.IsActive!==false&&f.IsActive!=="No",
    teamsGroupId:f.TeamsGroupId||"",
    teamsGroupName:f.TeamsGroupName||"",
    currentVersion:f.CurrentVersion||""
  };
}

export function projectDisplayName(p){
  if(!p)return"";
  const parts=[];
  if(p.customerName)parts.push(p.customerName);
  if(p.jobNumber)parts.push(p.jobNumber);
  const prefix=parts.join(" · ");
  return prefix?prefix+" – "+p.projectName:p.projectName;
}

export async function getProjects(){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_PROJECTS}/items?$expand=fields&$top=500`);
  return(res.value||[]).map(spToProject);
}

export async function upsertProject(token,project){
  const title=project.jobNumber?project.jobNumber+" "+project.projectName:project.projectName;
  const fields={Title:title,CustomerName:project.customerName||"",JobNumber:project.jobNumber||"",ProjectName:project.projectName||"",ProjectType:project.projectType||"customer",IsQuote:project.isQuote?true:false,IsActive:project.isActive!==false,TeamsGroupId:project.teamsGroupId||"",TeamsGroupName:project.teamsGroupName||"",CurrentVersion:project.currentVersion||""};
  if(project.spId){
    await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_PROJECTS}/items/${project.spId}/fields`,fields);
    return{...project,...fields,id:project.spId};
  }else{
    const res=await gql("POST",`/sites/${SP_SITE}/lists/${LIST_PROJECTS}/items`,{fields});
    return spToProject(res);
  }
}

export async function getTeamsGroups(){
  // Requires Group.Read.All — acquire with popup so only admins who click Sync Teams get prompted
  const accounts=msalInstance.getAllAccounts();
  let tok;
  try{tok=(await msalInstance.acquireTokenSilent({scopes:TEAMS_SCOPES,account:accounts[0]})).accessToken;}
  catch(e){tok=(await msalInstance.acquireTokenPopup({scopes:TEAMS_SCOPES})).accessToken;}
  const res=await fetch("https://graph.microsoft.com/v1.0/groups?$filter=resourceProvisioningOptions/Any(x:x eq 'Team')&$select=id,displayName,description&$top=999",{headers:{"Authorization":"Bearer "+tok}});
  const data=await res.json();
  return data.value||[];
}

// ── Task History ──────────────────────────────────────────────────────────
function spToHistory(item){
  const f=item.fields||item;
  return{
    id:String(item.id),
    taskId:f.TaskId||"",
    taskTitle:f.TaskTitle||"",
    listType:f.ListType||"tasks",
    action:f.Action||"",
    changedBy:f.ChangedBy||"",
    fieldName:f.FieldName||"",
    oldValue:f.OldValue||"",
    newValue:f.NewValue||"",
    details:f.Details||f.Title||"",
    changedAt:item.createdDateTime||""
  };
}

// Fire-and-forget — never blocks the calling action
export function logHistory(entry){
  gql("POST",`/sites/${SP_SITE}/lists/${LIST_HISTORY}/items`,{fields:{
    Title:entry.title||entry.action,
    TaskId:String(entry.taskId||""),
    TaskTitle:entry.taskTitle||"",
    ListType:entry.listType||"tasks",
    Action:entry.action||"",
    ChangedBy:entry.changedBy||"",
    FieldName:entry.fieldName||"",
    OldValue:String(entry.oldValue||""),
    NewValue:String(entry.newValue||""),
    Details:entry.details||""
  }}).catch(e=>console.warn("History log failed:",e));
}

export async function getTaskHistory(taskId){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_HISTORY}/items?$expand=fields&$filter=fields/TaskId eq '${String(taskId)}'&$orderby=createdDateTime desc&$top=100`);
  return(res.value||[]).map(spToHistory);
}

export async function getFullHistory(filters={}){
  let url=`/sites/${SP_SITE}/lists/${LIST_HISTORY}/items?$expand=fields&$orderby=createdDateTime desc&$top=500`;
  const res=await gql("GET",url);
  let items=(res.value||[]).map(spToHistory);
  if(filters.action) items=items.filter(i=>i.action===filters.action);
  if(filters.user) items=items.filter(i=>i.changedBy.toLowerCase().includes(filters.user.toLowerCase()));
  if(filters.from) items=items.filter(i=>i.changedAt>=filters.from);
  if(filters.to) items=items.filter(i=>i.changedAt<=filters.to);
  return items;
}

// ── Feedback ──────────────────────────────────────────────────────────────
function spToFeedback(item){
  const f=item.fields||item;
  return{
    id:String(item.id),spId:String(item.id),
    title:f.Title||"",
    feedbackType:f.FeedbackType||"enhancement",
    description:f.Description||f.TaskDescription||"",
    submittedBy:f.SubmittedBy||"",
    status:f.Status||"new",
    priority:f.Priority||"medium",
    screenshotUrls:safeParseArray(f.ScreenshotUrls),
    assignedTo:f.AssignedTo||"",
    resolutionNotes:f.ResolutionNotes||"",
    appVersion:f.AppVersion||"",
    replyHistory:safeParseArray(f.ReplyHistory),
    createdAt:item.createdDateTime||item.fields?.Created||""
  };
}

export async function getFeedback(){
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_FEEDBACK}/items?$expand=fields&$top=500&$orderby=createdDateTime desc`);
  return(res.value||[]).map(spToFeedback);
}

export async function submitFeedback(feedback){
  const fields={
    Title:feedback.title,
    FeedbackType:feedback.feedbackType,
    Description:feedback.description,
    SubmittedBy:feedback.submittedBy,
    Status:"new",
    Priority:feedback.priority||"medium",
    ScreenshotUrls:JSON.stringify(feedback.screenshotUrls||[]),
    AssignedTo:"",
    ResolutionNotes:"",
    AppVersion:"1.0"
  };
  const res=await gql("POST",`/sites/${SP_SITE}/lists/${LIST_FEEDBACK}/items`,{fields});
  return spToFeedback(res);
}

export async function updateFeedback(item){
  // Patch each field individually to isolate which one SP rejects
  const patches=[
    {Status:item.status},
    {ResolutionNotes:item.resolutionNotes||""},
    ...(item.assignedTo?[{AssignedTo:item.assignedTo}]:[])
  ];
  const errors=[];
  for(const fields of patches){
    try{
      console.log("[updateFeedback] PATCH fields:",JSON.stringify(fields));
      await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_FEEDBACK}/items/${item.spId}/fields`,fields);
      console.log("[updateFeedback] OK:",Object.keys(fields)[0]);
    }catch(e){
      console.error("[updateFeedback] FAILED field",Object.keys(fields)[0],":",e.message);
      errors.push(Object.keys(fields)[0]+": "+e.message);
    }
  }
  if(errors.length)throw new Error("Save partially failed — check console for details. "+errors.join("; "));
  return item;
}

export async function addFeedbackReply(item,entry){
  const history=[...(item.replyHistory||[]),entry];
  await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_FEEDBACK}/items/${item.spId}/fields`,{ReplyHistory:JSON.stringify(history)});
  return history;
}

export async function uploadScreenshot(token,file){
  const safe=file.name.replace(/[^a-z0-9._-]/gi,"_");
  const filename=Date.now()+"_"+safe;
  const res=await fetch(`https://graph.microsoft.com/v1.0/sites/${SP_SITE}/drive/root:/TaskHub_Screenshots/${filename}:/content`,{
    method:"PUT",
    headers:{"Authorization":"Bearer "+token,"Content-Type":file.type||"application/octet-stream"},
    body:file
  });
  if(!res.ok){const e=await res.text();throw new Error("Upload failed: "+e);}
  const data=await res.json();
  return data.webUrl||"";
}

export async function uploadTaskAttachment(file,taskId){
  const tok=await getToken();
  const safe=file.name.replace(/[^a-z0-9._-]/gi,"_");
  const filename=Date.now()+"_"+safe;
  const res=await fetch(`https://graph.microsoft.com/v1.0/sites/${SP_SITE}/drive/root:/TaskHub_Attachments/${filename}:/content`,{
    method:"PUT",
    headers:{"Authorization":"Bearer "+tok,"Content-Type":file.type||"application/octet-stream"},
    body:file
  });
  if(!res.ok){const e=await res.text();throw new Error("Upload failed: "+e);}
  const data=await res.json();
  return{t:"upload",n:file.name,u:data.webUrl||""};
}

export async function getM365Users(token){
  const res=await fetch("https://graph.microsoft.com/v1.0/users?$filter=accountEnabled eq true&$select=displayName,mail,userPrincipalName,jobTitle,department&$top=999",{headers:{"Authorization":"Bearer "+token}});
  const data=await res.json();
  return(data.value||[]).filter(u=>{
    const mail=(u.mail||u.userPrincipalName||"").toLowerCase();
    return mail.includes("@dacrobotics.com")||mail.includes("@dac-us.com");
  }).map(u=>({
    email:normEmail(u.mail||u.userPrincipalName||""),
    displayName:u.displayName||"",
    jobTitle:u.jobTitle||"",
    department:u.department||""
  }));
}

const TASKHUB_URL="https://taskhub.dacrobotics.com";
// ── ProductTrack Issues ───────────────────────────────────────────────────
function spToIssue(item){
  const f=item.fields||item;
  return{
    id:"i-"+String(item.id),
    spId:String(item.id),
    title:f.Title||"",
    issueType:f.IssueType||"bug_sw",
    severity:f.Severity||"medium",
    priorityRank:f.PriorityRank||999,
    status:f.Status||"new",
    product:f.ProductId||"",
    productVersion:f.ProductVersion||"",
    targetVersion:f.TargetVersion||"",
    desc:f.IssueDescription||"",
    steps:f.StepsToReproduce||"",
    resolution:f.Resolution||"",
    reporterEmail:normEmail(f.ReporterEmail||""),
    own:normEmail(f.OwnerEmail||""),
    source:f.Source||"internal",
    tags:safeParseArray(f.Tags),
    docs:safeParseArray(f.LinkedDocs),
    milestone:f.Milestone||"Backlog",
    notes:f.Notes||"",
    closedDate:f.ClosedDate?String(f.ClosedDate).slice(0,10):"",
    createdDate:f.CreatedDate?String(f.CreatedDate).slice(0,10):item.createdDateTime?item.createdDateTime.slice(0,10):""
  };
}
function issueToSp(issue){
  return{
    Title:issue.title,
    IssueType:issue.issueType||"bug_sw",
    Severity:issue.severity||"medium",
    PriorityRank:issue.priorityRank||999,
    Status:issue.status||"new",
    ProductId:issue.product||"",
    ProductVersion:issue.productVersion||"",
    TargetVersion:issue.targetVersion||"",
    IssueDescription:issue.desc||"",
    StepsToReproduce:issue.steps||"",
    Resolution:issue.resolution||"",
    ReporterEmail:issue.reporterEmail||"",
    OwnerEmail:issue.own||"",
    Source:issue.source||"internal",
    Tags:JSON.stringify(issue.tags||[]),
    LinkedDocs:JSON.stringify(issue.docs||[]),
    Milestone:issue.milestone||"Backlog",
    Notes:issue.notes||"",
    ClosedDate:issue.closedDate||"",
    CreatedDate:issue.createdDate||new Date().toISOString().slice(0,10)
  };
}
export async function getIssues(){
  if(LIST_ISSUES==="REPLACE_WITH_ISSUES_LIST_ID") return[];
  const res=await gql("GET",`/sites/${SP_SITE}/lists/${LIST_ISSUES}/items?$expand=fields&$top=500`);
  return(res.value||[]).map(spToIssue);
}
export async function createIssue(issue){
  if(LIST_ISSUES==="REPLACE_WITH_ISSUES_LIST_ID") throw new Error("TaskHub_Issues list not configured. Update LIST_ISSUES in config.js.");
  const res=await gql("POST",`/sites/${SP_SITE}/lists/${LIST_ISSUES}/items`,{fields:issueToSp(issue)});
  return spToIssue(res);
}
export async function updateIssue(issue){
  if(LIST_ISSUES==="REPLACE_WITH_ISSUES_LIST_ID") throw new Error("TaskHub_Issues list not configured.");
  await gql("PATCH",`/sites/${SP_SITE}/lists/${LIST_ISSUES}/items/${issue.spId}/fields`,issueToSp(issue));
  return issue;
}
export async function deleteIssue(issue){
  if(LIST_ISSUES==="REPLACE_WITH_ISSUES_LIST_ID") throw new Error("TaskHub_Issues list not configured.");
  await gql("DELETE",`/sites/${SP_SITE}/lists/${LIST_ISSUES}/items/${issue.spId}`);
}

const BLUE="#1D5FA5";
const GOLD="#E89A0A";

function emailShell(bodyContent){
  return`<!DOCTYPE html><html><body style="margin:0;padding:0;background:#F1F5F9;font-family:system-ui,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0"><tr><td align="center" style="padding:32px 16px;">
<table width="600" cellpadding="0" cellspacing="0" style="background:#FFFFFF;border-radius:12px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
  <tr><td style="background:${BLUE};padding:20px 32px;">
    <span style="color:#FFFFFF;font-size:20px;font-weight:700;letter-spacing:0.5px;">DAC</span>
    <span style="color:${GOLD};font-size:14px;font-weight:700;letter-spacing:3px;margin-left:6px;">ROBOTICS</span>
    <span style="color:rgba(255,255,255,0.6);font-size:13px;margin-left:10px;">/ TaskHub</span>
  </td></tr>
  <tr><td style="padding:28px 32px;">${bodyContent}</td></tr>
  <tr><td style="padding:16px 32px;background:#F8FAFC;border-top:1px solid #E2E8F0;text-align:center;">
    <a href="${TASKHUB_URL}" style="display:inline-block;background:${BLUE};color:#FFFFFF;padding:12px 32px;border-radius:8px;text-decoration:none;font-weight:600;font-size:14px;">Open TaskHub</a>
    <p style="margin:12px 0 0;font-size:11px;color:#94A3B8;">DAC TaskHub · dacrobotics.com</p>
  </td></tr>
</table></td></tr></table></body></html>`;
}

function fmtEmailDate(d){if(!d)return"No date";const[y,m,day]=d.split("-");const months=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];return`${months[parseInt(m)-1]} ${parseInt(day)}, ${y}`;}

async function sendMailViaGraph(toEmail,subject,htmlBody){
  const message={message:{subject,body:{contentType:"HTML",content:htmlBody},toRecipients:[{emailAddress:{address:toEmail}}]},saveToSentItems:false};
  const token=await getToken();
  const res=await fetch("https://graph.microsoft.com/v1.0/me/sendMail",{method:"POST",headers:{"Authorization":"Bearer "+token,"Content-Type":"application/json"},body:JSON.stringify(message)});
  if(res.status!==202&&res.status!==200&&res.status!==204){const e=await res.text();throw new Error("sendMail failed: "+e);}
}

export async function sendAssignmentEmail(task,assigneeName,ownerName){
  const priLabels={high:"🔴 High",medium:"🟡 Medium",low:"🟢 Low"};
  const body=emailShell(`
    <p style="margin:0 0 6px;font-size:15px;color:#475569;">Hi ${assigneeName},</p>
    <p style="margin:0 0 20px;font-size:15px;color:#1E293B;">A new task has been assigned to you in <strong>DAC TaskHub</strong>:</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #E2E8F0;border-radius:8px;overflow:hidden;margin-bottom:20px;">
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;width:120px;">Task</td><td style="padding:10px 16px;font-size:14px;font-weight:600;color:#1E293B;">${task.title}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Priority</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${priLabels[task.pri]||task.pri}</td></tr>
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Due Date</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${fmtEmailDate(task.dueDate)}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Assigned By</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${ownerName}</td></tr>
      ${task.desc?`<tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Description</td><td style="padding:10px 16px;font-size:14px;color:#475569;border-top:1px solid #F1F5F9;">${task.desc}</td></tr>`:""}
    </table>
    <p style="margin:0;font-size:13px;color:#94A3B8;">Log in to TaskHub to accept or decline this task.</p>`);
  await sendMailViaGraph(task.asgn,`New task assigned: ${task.title}`,body);
}

export async function sendUpdateRequestEmail(task,requesterName,assigneeName,note=""){
  const body=emailShell(`
    <p style="margin:0 0 6px;font-size:15px;color:#475569;">Hi ${assigneeName},</p>
    <p style="margin:0 0 20px;font-size:15px;color:#1E293B;"><strong>${requesterName}</strong> is requesting a status update on the following task:</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #E2E8F0;border-radius:8px;overflow:hidden;margin-bottom:20px;">
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;width:120px;">Task</td><td style="padding:10px 16px;font-size:14px;font-weight:600;color:#1E293B;">${task.title}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Due Date</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${fmtEmailDate(task.dueDate)}</td></tr>
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Current Status</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${task.sta.replace(/_/g," ")}</td></tr>
    </table>
    ${note?`<div style="background:#FFFBEB;border-left:4px solid #E89A0A;border-radius:0 8px 8px 0;padding:12px 16px;margin-bottom:20px;"><p style="margin:0 0 4px;font-size:11px;font-weight:600;color:#92400E;text-transform:uppercase;letter-spacing:0.5px;">Note from ${requesterName}</p><p style="margin:0;font-size:14px;color:#1E293B;">${note}</p></div>`:""}
    <p style="margin:0;font-size:13px;color:#94A3B8;">Please log in to TaskHub to update the status or add a note.</p>`);
  await sendMailViaGraph(task.asgn,`Update requested: ${task.title}`,body);
}

// ── Feedback emails ───────────────────────────────────────────────────────────

const CALLBACK_BASE="https://taskhub-functions-dfbwdzdgbbdfgffj.centralus-01.azurewebsites.net/api/feedbackCallback";
const FB_SECRET="th-fb-taskhub-2026";

// Simple HMAC-style token using Web Crypto — matches azure-functions feedbackCallback.js
async function feedbackToken(spId){
  const enc=new TextEncoder();
  const key=await crypto.subtle.importKey("raw",enc.encode(FB_SECRET),{name:"HMAC",hash:"SHA-256"},false,["sign"]);
  const sig=await crypto.subtle.sign("HMAC",key,enc.encode(String(spId)));
  return Array.from(new Uint8Array(sig)).map(b=>b.toString(16).padStart(2,"0")).join("").slice(0,20);
}

const TYPE_LABELS={bug:"Bug Report",enhancement:"Enhancement Request",question:"Question"};
const PRI_LABELS={high:"🔴 High",medium:"🟡 Medium",low:"🟢 Low"};
const STATUS_LABELS={new:"New",in_review:"In Review",resolved:"Resolved",wont_fix:"Won't Fix",closed:"Closed"};

export async function sendFeedbackReplyEmail(feedback,replyText,senderName){
  const body=emailShell(`
    <p style="margin:0 0 6px;font-size:15px;color:#475569;">Hi ${feedback.submittedBy.split("@")[0].split(/[._]/).map(p=>p.charAt(0).toUpperCase()+p.slice(1)).join(" ")},</p>
    <p style="margin:0 0 20px;font-size:15px;color:#1E293B;"><strong>${senderName}</strong> has replied to your ${TYPE_LABELS[feedback.feedbackType]||"feedback"}:</p>
    <div style="background:#F0F6FF;border-left:4px solid ${BLUE};border-radius:0 8px 8px 0;padding:14px 18px;margin-bottom:20px;">
      <p style="margin:0;font-size:14px;color:#1E293B;line-height:1.7;white-space:pre-wrap;">${replyText}</p>
    </div>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #E2E8F0;border-radius:8px;overflow:hidden;margin-bottom:20px;">
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;width:130px;">Your ${TYPE_LABELS[feedback.feedbackType]||"Feedback"}</td><td style="padding:10px 16px;font-size:14px;font-weight:600;color:#1E293B;">${feedback.title}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Status</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${STATUS_LABELS[feedback.status]||feedback.status}</td></tr>
      ${feedback.resolutionNotes?`<tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Resolution Notes</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;white-space:pre-wrap;">${feedback.resolutionNotes}</td></tr>`:""}
    </table>
    <p style="margin:0;font-size:13px;color:#94A3B8;">If you have further questions, please use the Report Issue button in TaskHub.</p>`);
  await sendMailViaGraph(feedback.submittedBy,`Re: ${feedback.title}`,body);
}

export async function sendResolutionEmail(feedback,senderName){
  const tok=await feedbackToken(feedback.spId);
  const verifyUrl=`${CALLBACK_BASE}?id=${feedback.spId}&action=verify&token=${tok}`;
  const reopenUrl=`${CALLBACK_BASE}?id=${feedback.spId}&action=reopen&token=${tok}`;
  const submitterFirst=feedback.submittedBy.split("@")[0].split(/[._]/).map(p=>p.charAt(0).toUpperCase()+p.slice(1)).join(" ");
  const body=emailShell(`
    <p style="margin:0 0 6px;font-size:15px;color:#475569;">Hi ${submitterFirst},</p>
    <p style="margin:0 0 20px;font-size:15px;color:#1E293B;">Good news — your ${TYPE_LABELS[feedback.feedbackType]||"feedback"} has been resolved. Please verify the fix when you get a chance.</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #E2E8F0;border-radius:8px;overflow:hidden;margin-bottom:20px;">
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;width:130px;">Type</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;">${TYPE_LABELS[feedback.feedbackType]||feedback.feedbackType}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Title</td><td style="padding:10px 16px;font-size:14px;font-weight:600;color:#1E293B;border-top:1px solid #F1F5F9;">${feedback.title}</td></tr>
      <tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Priority</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${PRI_LABELS[feedback.priority]||feedback.priority||"Medium"}</td></tr>
      <tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Resolved By</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;">${senderName}</td></tr>
      ${feedback.description?`<tr style="background:#F8FAFC;"><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Your Description</td><td style="padding:10px 16px;font-size:14px;color:#475569;border-top:1px solid #F1F5F9;">${feedback.description}</td></tr>`:""}
      ${feedback.resolutionNotes?`<tr><td style="padding:10px 16px;font-size:12px;font-weight:600;color:#64748B;text-transform:uppercase;letter-spacing:0.5px;border-top:1px solid #F1F5F9;">Resolution Notes</td><td style="padding:10px 16px;font-size:14px;color:#1E293B;border-top:1px solid #F1F5F9;white-space:pre-wrap;">${feedback.resolutionNotes}</td></tr>`:""}
    </table>
    <p style="margin:0 0 16px;font-size:14px;font-weight:600;color:#1E293B;text-align:center;">Does this fix your issue?</p>
    <table width="100%" cellpadding="0" cellspacing="0"><tr>
      <td align="center" style="padding:0 6px 0 0;">
        <a href="${verifyUrl}" style="display:block;background:#059669;color:#FFFFFF;padding:14px 20px;border-radius:10px;text-decoration:none;font-weight:700;font-size:14px;text-align:center;">✅ Yes, the fix works!</a>
      </td>
      <td align="center" style="padding:0 0 0 6px;">
        <a href="${reopenUrl}" style="display:block;background:#F1F5F9;color:#475569;padding:14px 20px;border-radius:10px;text-decoration:none;font-weight:600;font-size:14px;text-align:center;border:1px solid #E2E8F0;">❌ Still having issues</a>
      </td>
    </tr></table>
    <p style="margin:16px 0 0;font-size:12px;color:#94A3B8;text-align:center;">Clicking "Still having issues" will let you leave a comment and reopen this item for review.</p>`);
  await sendMailViaGraph(feedback.submittedBy,`Fix Ready to Verify: ${feedback.title}`,body);
}
